<script setup lang="ts">
import EmailTiptapToolbar from './EmailTiptapToolbar.vue'

import type { FooterAlignment } from '../../types'
import type { Editor } from '@tiptap/vue-3'

withDefaults(
  defineProps<{
    editor?: Editor | undefined
    visible: boolean
    variables?: { code: string; label: string }[]
    colorPresets?: { color: string; label: string }[]
    hideAlign?: boolean
    blockAlign?: FooterAlignment
    disabled?: boolean
  }>(),
  {
    editor: undefined,
    visible: true,
    variables: () => [],
    colorPresets: () => [],
    hideAlign: false,
    blockAlign: undefined,
    disabled: false
  }
)

const emit = defineEmits<{
  (e: 'insert-variable', code: string): void
  (e: 'update:align', align: FooterAlignment): void
  (e: 'update:blockAlign', align: FooterAlignment): void
}>()
</script>

<template>
  <Teleport v-if="visible && (editor || disabled)" to="#email-toolbar-target" defer>
    <EmailTiptapToolbar
      :editor="editor"
      :variables="variables"
      :color-presets="colorPresets"
      :hide-align="hideAlign"
      :block-align="blockAlign"
      :disabled="disabled"
      @insert-variable="emit('insert-variable', $event)"
      @update:block-align="emit('update:blockAlign', $event)"
    />
  </Teleport>
</template>
